import moment from "moment";
import Api from "./axiosVersion1";
import {
  appendQueryString,
  buildQueryString,
  buildRepeatedQueryParam,
  createAbortSignalController,
  formUrlEncodedConfig,
} from "./serviceUtils";

let controller;

export const getWorklog = async (card_id) => {
  return await Api.get(`/card_log/${card_id}/card`);
};

export const getMissingWorklog = async () => {
  return await Api.get(`/user_missing_report`);
};

export const createtMissingWorklog = async (data) => {
  return await Api.post(`/create_user_leave`, data, formUrlEncodedConfig);
};

export const deleteWorklog = async (worklog_id) => {
  return await Api.delete(`/card_log/${worklog_id}`);
};

export const createWorklog = async (data) => {
  return await Api.post(`/card_log`, data, formUrlEncodedConfig);
};

export const getWorklogDetail = async (id) => {
  return await Api.get(`/card_log/${id}`);
};

export const updateWorklogDetail = async (data) => {
  return await Api.put(`/card_log/${data.card_log_id}`, data.data, formUrlEncodedConfig);
};

export const getWorklogHistory = async (
  user,
  checkedList,
  dateRange,
  epics,
  download = false,
  by_task = false
) => {
  controller = createAbortSignalController(controller);
  const signal = controller.signal;
  const query = [
    buildRepeatedQueryParam(
      "user_id",
      (user || []).map((item) => item.user_id)
    ),
    buildRepeatedQueryParam("boards", checkedList || []),
    dateRange
      ? buildQueryString({
          start_date: moment(dateRange.startDate).format("YYYY-MM-DD"),
          end_date: moment(dateRange.endDate).format("YYYY-MM-DD"),
        })
      : "",
    buildRepeatedQueryParam("epics", epics || []),
    download
      ? buildQueryString({ download: true, by_task })
      : "",
  ]
    .filter(Boolean)
    .join("&");

  if (dateRange && !download) {
    return await Api.get(appendQueryString(`/card_logs`, query), {
      signal: signal,
    });
  } else if (download) {
    return await Api.get(appendQueryString(`/card_logs`, query), {
      signal: signal,
      headers: {
        "Content-Type": "text/csv",
      },
    });
  } else {
    return await Api.get(appendQueryString(`/card_logs`, query), {
      signal: signal,
    });
  }
};

export const moveWorklog = async (data) => {
  return await Api.put(`/move_card_logs`, data);
};

export const getWorklogBoard = async (board_id, milestoneId) => {
  return await Api.get(
    appendQueryString(`/card_logs/${board_id}/board`, buildQueryString({
      milestone_id: milestoneId,
    }))
  );
};
